export default __webpack_public_path__ + "static/topaz-crystal-a2a88fad014576de4dda63a78a7c5b6a.png";